import Vue from 'vue'
import Router from 'vue-router'

// pages
import Home from '@/pages/home/home.vue'
import VrInfo from  '@/pages/vrinfo/vrinfo'
import classify from "@/pages/classify/classify";
import search from "@/pages/search/search";
import searchInfo from "@/pages/searchInfo/searchInfo";
import vrView from "@/pages/vrView/vrView";

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
    mode:'history',
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
            meta:{
                // 顶部导航是否在当前页面渐变。
                navShow:true, //  方法：$route.meta.navShow
                full:false // 是否全屏
            }
        },
        {
            path: '/vrinfo',
            name: 'vrinfo',
            component: VrInfo,
            meta:{
                navShow:false,
                full:false
            }
        },
        {
            path: '/classify',
            name: 'classify',
            component: classify,
            meta:{
                navShow:false,
                full:false
            }
        },
        {
            path: '/search',
            name: 'search',
            component: search,
            meta:{
                navShow:false,
                full:false
            }
        },
        {
            path: '/searchInfo',
            name: 'searchInfo',
            component: searchInfo,
            meta:{
                navShow:false,
                full:false
            }
        },
        {
            path: '/vrview',
            name: 'vrview',
            component: vrView,
            meta:{
                navShow:false,
                full:true
            }
        },
    ]
})

router.beforeEach((to,from,next)=>{
    // console.log(to);
    // console.log(from);
    // 进入下一路由时重置scrollTop
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    next();
})
export default router;


